import { runtimeConfig } from '@/config/runtime-config';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

let loaded = false;

/** Injects GTM once, only when the environment configures a container id. */
export function initAnalytics(): void {
  const id = runtimeConfig().GTM_ID;
  if (!id || loaded) return;
  loaded = true;
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(script);
}

/**
 * Funnel events: signup_started, account_created, step_completed {step},
 * application_submitted, plus Pageview {onboardingStep} for the hub's existing GTM triggers.
 */
export function trackEvent(
  event: string,
  data: Record<string, string | number | boolean> = {},
): void {
  if (!runtimeConfig().GTM_ID) return;
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ event, ...data });
}

export function trackPageview(onboardingStep: string): void {
  trackEvent('Pageview', { onboardingStep });
}
